import { render, staticRenderFns } from "./linktree.vue?vue&type=template&id=a230a710&scoped=true&"
import script from "./linktree.vue?vue&type=script&lang=js&"
export * from "./linktree.vue?vue&type=script&lang=js&"
import style0 from "./linktree.vue?vue&type=style&index=0&id=a230a710&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a230a710",
  null
  
)

export default component.exports